"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFilterTelemetryProcessor = void 0;
/**
 * Creates a filter telemetry processor function that determines whether to include telemetry data
 * based on a provided filter function and a sampling function.
 *
 * @param filterFn - A function that filters telemetry envelopes based on custom criteria.
 *                   It should return `true` for envelopes to be sampled and `false` otherwise.
 * @param sampler - A function that determines whether to keep telemetry based on its ID.
 *                  It should return `true` to include telemetry and `false` to exclude it.
 * @returns A telemetry processor function that evaluates both the filter and sampling criteria.
 * @example
 * ```typescript
 * const telemetryProcessor = createFilterTelemetryProcessor(
 *   (envelope) => envelope.data.baseType === 'MetricData' && ['LCP', 'CLS', 'INP'].includes(envelope.name),
 *   createFixedRateSampler(10) // 10% sampling
 * );
 *
 * const shouldInclude = telemetryProcessor(envelope);
 * console.log(shouldInclude); // Logs true or false based on filter and sampling logic
 * ```
 */
const createFilterTelemetryProcessor = (filterFn, sampler) => telemetryRecord => {
  if (!filterFn(telemetryRecord)) {
    return true; // Keep if filter condition is not met
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- exists
  const telemetryId = telemetryRecord.tags?.['ai.operation.id'];
  return sampler(telemetryId); // Pass to the sampler
};
exports.createFilterTelemetryProcessor = createFilterTelemetryProcessor;
